import { motion } from 'framer-motion';
import './about.css'; // Create this new CSS file

export default function About() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5 }
    }
  };

  const statVariants = {
    hover: { scale: 1.05, transition: { duration: 0.2 } }
  };

  return (
    <motion.section 
      className="about-section"
      id='about'
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
      variants={containerVariants}
    >
      <div className="about-container">
        <motion.h2 variants={itemVariants}>About Globepawa Ventures</motion.h2>
        
        <motion.p variants={itemVariants} className="lead-text">
          Globepawa Ventures is a dynamic tech company offering innovative solutions for the digital age.
        </motion.p>

        <motion.p variants={itemVariants}>
          Our team is composed of skilled developers and marketing strategists dedicated to helping businesses thrive in an increasingly digital world.
        </motion.p>

        <motion.p variants={itemVariants} className="highlight-text">
          At Globepawa Ventures, innovation meets execution.
        </motion.p>

        <motion.div className="stats" variants={itemVariants}>
          <motion.div className="stat" variants={statVariants} whileHover="hover">
            <h3>50+</h3>
            <p>Projects Delivered</p>
            <div className="stat-decoration"></div>
          </motion.div>
          <motion.div className="stat" variants={statVariants} whileHover="hover">
            <h3>15+</h3>
            <p>Live Streaming Events</p>
            <div className="stat-decoration"></div>
          </motion.div>
          <motion.div className="stat" variants={statVariants} whileHover="hover">
            <h3>10+</h3>
            <p>Years Combined Experience</p>
            <div className="stat-decoration"></div>
          </motion.div>
        </motion.div>

      </div>
    </motion.section>
  );
}